import { useQuery } from '@tanstack/react-query';
import React from 'react';
import type { TimeCardShift } from '../../../../../js/api';
import { AssignmentsService } from '../../../../../js/api';
import { ActivityLog } from '../../../components/activity-log';
import { Dialog, DialogBody, DialogTitle } from '../../../components/dialog';
import type { ActivityHistory } from '../../../utils/activity-types';
import { TIMECARD_SHIFT_CHANGE_HISTORY_QUERY_KEY } from './queryKeys';

export const ShiftHistoryModal: React.FC<{
  open: boolean;
  onClose: () => void;
  shift?: TimeCardShift;
}> = ({ open, onClose, shift }) => {
  const { data: changeHistory } = useQuery({
    queryKey: [TIMECARD_SHIFT_CHANGE_HISTORY_QUERY_KEY, shift?.id],
    queryFn: () =>
      AssignmentsService.assignmentsTimecardShiftChangeHistoryRetrieve({
        id: shift!.id,
        sort: 'desc',
      }),
    enabled: !!shift?.id && open,
  });

  const shiftDate = shift
    ? `${shift.start_on} ${shift.start_time?.slice(0, 5)} – ${shift.end_time?.slice(0, 5)}`
    : '';

  return (
    <Dialog open={open} onClose={onClose} size="lg">
      <DialogTitle>
        <>
          Shift History
          {shiftDate && (
            <div className="tw:text-xs tw:text-zinc-500 tw:font-normal">{shiftDate}</div>
          )}
        </>
      </DialogTitle>
      <DialogBody>
        <ActivityLog
          enableUpdatesFilter={true}
          changeHistory={changeHistory as ActivityHistory[] | undefined}
        />
      </DialogBody>
    </Dialog>
  );
};
